import DarkBgCardsFrame from "@/components/darkBgCards";
import { OFFERINGS_CONSTANTS } from "./constants";

const OfferingsComp = () => {
  return (
    <DarkBgCardsFrame
      {...OFFERINGS_CONSTANTS}
      columns={{ base: 1, md: 3 }}
      spacing={{ base: 4, md: 12 }}
    />
  );
};

export default OfferingsComp;
